import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { amber, green } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const variantStyles = {
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: '#d32f2f', // theme.palette.error.dark equivalent
  },
  info: {
    backgroundColor: '#1976d2',
  },
  warning: {
    backgroundColor: amber[700],
  },
};

const NotificationContent = (props) => {
  const { className, message, onClose, variant, id, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={clsx(className)}
      aria-describedby="client-snackbar"
      style={variantStyles[variant]}
      message={
        <span id="client-snackbar" className="flex items-center text-sm">
          <Icon className="text-base mr-2 opacity-90" />
          {typeof message === 'object' ? (message.errorDetail ? message.errorDetail : message) : message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={() => onClose(message)}
          size="large"
        >
          <CloseIcon className="text-base" />
        </IconButton>,
      ]}
      {...other}
    />
  );
};

NotificationContent.propTypes = {
  className: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClose: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  id: PropTypes.string,
};

NotificationContent.defaultProps = {
  className: '',
  message: '',
  variant: 'info',
  id: '',
};

export default NotificationContent;
